export const isLocalDevelopment = ()=> {
    const url = window?.location.origin
    if(url?.includes('localhost')) return true
    return false
}